import React, { useState } from "react";
import api from "../api";
import "./LoginPage.css";

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await api.post("/auth/forgot-password", { email });
      setMessage("If that email exists, a reset link has been sent.");
    } catch {
      setMessage("An error occurred. Try again.");
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h2 className="login-title">Reset Password</h2>
        {message && <p className="login-error">{message}</p>}
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="login-input"
          />
          <button type="submit" className="login-button">Send reset link</button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
